import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { media } from "@atlaskit/primitives/responsive";

import { SparklesIcon, ThickSparklesIcon } from "@/components/adg4/icons";

import HeaderTextBlock from "../header-text-block";

const exploreStyle = css({
    [media.below.sm]: {
        maxWidth: "400px"
    }
});

const largeSparklesIconContainerStyles = css({
    "position": "absolute",
    "& svg": {
        position: "relative",
        insetBlockEnd: "25px",
        insetInlineEnd: "5px"
    },
    [media.below.md]: {
        display: "none"
    }
});

const mediumSparklesIconContainerStyles = css({
    "position": "absolute",
    "& svg": {
        position: "relative",
        insetBlockEnd: "12px",
        insetInlineEnd: "5px"
    },
    [media.above.md]: {
        display: "none"
    },
    [media.below.sm]: {
        display: "none"
    }
});

const smallSparklesIconContainerStyles = css({
    "position": "absolute",
    "& svg": {
        position: "relative",
        insetBlockEnd: "8px",
        insetInlineEnd: "3px"
    },
    [media.above.sm]: {
        display: "none"
    }
});

export const ExploreMoreSection = () => {
    return (
        <HeaderTextBlock
            header={
                <div css={exploreStyle}>
                    <FormattedMessage
                        id="ConfluenceSoftwarePageTemplate.heroHeaderExploreMoreOfConfluence"
                        defaultMessage="Explore more of Confluence"
                    />
                    <span css={largeSparklesIconContainerStyles}>
                        <SparklesIcon width={"120"} height={"80"} />
                    </span>
                    <span css={mediumSparklesIconContainerStyles}>
                        <SparklesIcon width={"90"} height={"60"} />
                    </span>
                    <span css={smallSparklesIconContainerStyles}>
                        <ThickSparklesIcon width={"60"} height={"40"} />
                    </span>
                </div>
            }
            subHeader={
                <FormattedMessage
                    id="ConfluenceSoftwarePage.heroHeaderExploreMoreOfConfluence.subHeading"
                    defaultMessage="Create, collaborate, and connect your team's knowledge, all in one place"
                />
            }
        />
    );
};

export default ExploreMoreSection;
